import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import InstagramFab from "@/components/site/InstagramFab";
import MobileActionBar from "@/components/site/MobileActionBar";
import FestiveBanner from "@/components/site/FestiveBanner";
import { GrainOverlay } from "@/components/site/Decor";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";

function App() {
  const [banner, setBanner] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("festiveClosed") === "1") setBanner(false);
  }, []);

  const closeBanner = () => {
    setBanner(false);
    localStorage.setItem("festiveClosed", "1");
  };

  return (
    <div className="App bg-bone">
      <BrowserRouter>
        <SmoothScroll>
          <GrainOverlay />
          {banner && <FestiveBanner onClose={closeBanner} />}
          <Navbar bannerOffset={banner} />
          <WhatsAppFab />
          <InstagramFab />
          <main>
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer />
          <div className="h-14 md:hidden" aria-hidden="true" />
          <MobileActionBar />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-center" theme="light" />
    </div>
  );
}

export default App;
